import {
  CHOOSE_TEAMS_INPUTS,
  KICKOFF_INPUTS,
  KICKOFF_YARDLINE,
  KICK_OR_RECEIVE_INP,
  OFFENSE_DEFENSE_INP,
  REGULAR_PLAY_INPUTS,
  TEventTypes,
  TQuarters,
} from '@/constants';
import {
  ITeams,
  TCoinTossEvents,
  TKickoffEvents,
  TMetaFuncInput,
  TPlays,
  TRegularPlayEvents,
  TTeam,
  TTeamSide,
  TWorkflowType,
} from '@/types';

export const onCoinTossWinnerSelected = ({ send, payload, generalState, playFlowState }: TMetaFuncInput) => {
  const { teams } = generalState;
  const winningTeamData = teams[payload.value as keyof ITeams];

  playFlowState.pushEvent(
    {
      eventTypeId: TEventTypes.COIN_TOSS_HOME_WIN,
      value: payload.value === TTeam.HOME,
    },
    generalState.currentGame.gameId
  );

  playFlowState.setActiveTeam(payload.value as TTeam);

  // if overtime ask for offence defence, else to kick or receive
  if (playFlowState.currentQuarter > TQuarters.Q4) {
    send(TCoinTossEvents.TO_OFFENCE_DEFENCE, {
      nextStateInput: OFFENSE_DEFENSE_INP(winningTeamData),
    });
  } else {
    send(TCoinTossEvents.ON_SELECTED_WINNER, {
      nextStateInput: KICK_OR_RECEIVE_INP(winningTeamData),
    });
  }
};

export const onKickOrReceiveSelected = ({ send, payload, generalState, playFlowState }: TMetaFuncInput) => {
  const { teams } = generalState;

  playFlowState.pushEvent(
    {
      eventTypeId: TEventTypes.WINNER_KICKING,
      value: payload.value === TPlays.KICK,
    },
    generalState.currentGame.gameId
  );

  // active team should be the kicking team
  if (payload.value === TPlays.RECEIVE) {
    playFlowState.setActiveTeam(playFlowState.activeTeam === TTeam.HOME ? TTeam.AWAY : TTeam.HOME);
  }

  send(TCoinTossEvents.TO_SELECT_SIDE, {
    nextStateInput: CHOOSE_TEAMS_INPUTS(teams.home, teams.away, TCoinTossEvents.BACK),
  });
};

export const onOffenseOrDefenseSelected = ({
  send,
  payload,
  generalState,
  playFlowState,
}: TMetaFuncInput) => {
  const { teams } = generalState;

  // active team should be the offence team
  if (payload.value === TPlays.DEFENCE) {
    playFlowState.setActiveTeam(playFlowState.activeTeam === TTeam.HOME ? TTeam.AWAY : TTeam.HOME);
  }

  // send to TO_SELECT_SIDE
  send(TCoinTossEvents.TO_SELECT_SIDE, {
    nextStateInput: CHOOSE_TEAMS_INPUTS(teams.home, teams.away, TCoinTossEvents.BACK_TO_OFFENCE_DEFENCE),
  });
};

export const onSideSelected = ({ send, payload, generalState, playFlowState }: TMetaFuncInput) => {
  playFlowState.setTeamSides(payload.value as TTeam, payload.value === TTeam.HOME ? TTeam.AWAY : TTeam.HOME);

  let activeTeamSide = TTeamSide.RIGHT;
  if (playFlowState.activeTeam === payload.value) {
    activeTeamSide = TTeamSide.LEFT;
  }
  const oppTeamSide = activeTeamSide === TTeamSide.RIGHT ? TTeamSide.LEFT : TTeamSide.RIGHT;
  playFlowState.setDriveDirection(oppTeamSide);

  // if overtime
  if (playFlowState.currentQuarter === TQuarters.OT1) {
    playFlowState.startOT1(generalState.currentGame.gameId, oppTeamSide);

    send(TCoinTossEvents.TO_REGULAR_PLAY, {
      ctxUpdate: {
        currentWorkflow: TWorkflowType.REGULAR_PLAY,
      },
      nextStateInput: REGULAR_PLAY_INPUTS(TRegularPlayEvents.BACK_TO_COIN_TOSS),
    });
  } else {
    playFlowState.setYardline(KICKOFF_YARDLINE, activeTeamSide);
    send(TCoinTossEvents.ON_SELECTED_WINNER, {
      nextStateInput: KICKOFF_INPUTS(TKickoffEvents.TO_COIN_TOSS_SELECT_SIDE),
      ctxUpdate: {
        currentWorkflow: TWorkflowType.KICKOFF,
      },
    });
  }
};
